import FieldWrapper from 'components/FieldWrapper';
import Select, {Props as SelectProps} from 'components/Select';

interface Props extends SelectProps {
  label?: string;
  error?: string;
}
function SelectField({label, error, size = 'md', ...restProps}: Props) {
  return (
    <FieldWrapper label={label} error={error}>
      <Select size={size} {...restProps} />
    </FieldWrapper>
  );
}

export default SelectField;
